module.exports = __webpack_public_path__ + "img/rec-marker.af01400d.svg";